import { ifAuthenticated, mustBeAdmin } from "../util/auth";

const Leave = () => import("../components/content/leave/leave");

export const leaveRoute = {
  path: "/leave-management",
  component: Leave,
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeAdmin
};
